const { styled, Button } = require('@mui/material');

exports.CustomButton = styled(Button)({
  background: 'linear-gradient(89.99deg, #008ED4 0.01%, #0069CD 100.14%)',
  fontFamily: 'Roboto',
  fontWeight:500
});
